module.exports = __webpack_public_path__ + "media/images/ww250-4476c1e3c9bfdc840241e5a961b71ee6.svg";